export default __webpack_public_path__ + "static/media/security-color.7376443d.svg";